/* ─── Feed Card Skeleton ─── */
function FeedSkeleton() {
  return (
    <div className="w-full animate-pulse">
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="w-9 h-9 rounded-full bg-muted" />
        <div className="space-y-1.5">
          <div className="w-24 h-3 bg-muted rounded" />
          <div className="w-16 h-2 bg-muted rounded" />
        </div>
      </div>
      <div className="aspect-[4/5] bg-muted" />
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-4">
          <div className="w-6 h-6 rounded bg-muted" />
          <div className="w-6 h-6 rounded bg-muted" />
          <div className="w-6 h-6 rounded bg-muted" />
        </div>
        <div className="w-6 h-6 rounded bg-muted" />
      </div>
      <div className="px-4 pb-4 space-y-1.5">
        <div className="w-full h-3 bg-muted rounded" />
        <div className="w-2/3 h-3 bg-muted rounded" />
      </div>
    </div>
  );
}

export function FeedSkeletons() {
  return (
    <div className="divide-y divide-border/30">
      {Array.from({ length: 3 }).map((_, i) => (
        <FeedSkeleton key={i} />
      ))}
    </div>
  );
}

export function ExploreSkeleton() {
  return (
    <div className="grid grid-cols-3 gap-0.5">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className="aspect-square bg-muted animate-pulse" />
      ))}
    </div>
  );
}
